const IssuePreviewOffice = () => import("@/views/base/IssuePreviewOffice.vue");
const IssueMapOffice = () => import("@/views/base/IssueMapOffice.vue");
const IssueProfileOffice = () => import("@/views/base/IssueProfileOffice.vue");

const fnsRoutes = {
  mainRoute: "base/IssuesPreviewOffice",
  children: [
    {
      path: "base/IssuesPreviewOffice",
      name: "Issues Preview Office",
      component: IssuePreviewOffice
    },
    {
      path: "issueOffice",
      name: "Issues Profile Office",
      component: IssueProfileOffice,
      props(route) {
        return route.query || {};
      }
    },
    {
      path: "base/IssuesMapOffice",
      name: "Map By Region",
      component: IssueMapOffice
    }
  ]
};
export default fnsRoutes;
